import { createSelector } from '@reduxjs/toolkit'
import { useSelector } from 'Flux/index.js'
import { orderSlice } from 'Flux/Slice/Order/OrderSlice.js'
import type { State } from 'Flux/Slice/index.js'
import type { OrderProcessingData } from '../../../../Generated/OrderProcessingData.js'

export const useGetOtuProcessingDataSelector: () => OrderProcessingData | null = () => {
  return useSelector(getOtuProcessingData)
}

const selectOtuProcessingData = (state: typeof State) => state[orderSlice.name].otuProcessingData

export const getOtuProcessingData = createSelector(selectOtuProcessingData, (otuProcessingData) =>
  otuProcessingData == null ? null : otuProcessingData
)

const selectOtuProcessingDataSettled = (state: typeof State) => state[orderSlice.name].otuProcessingDataSettled

export const useIsOtuProcessingDataSettledSelector: () => boolean = () => useSelector(selectOtuProcessingDataSettled)
